module.exports = __webpack_public_path__ + "r-v3/img/ico_logout.4a1d2dd0.svg";